<template>
  <main id="js-page-content" role="main" class="page-content">
    <div class="row">
      <div class="subheader col-6">
        <h1 class="subheader-title">口座マスタ編集</h1>
      </div>
      <!-- Right content on content header A nice area to add graphs or buttons -->
      <div class="subheader-block ml-auto demo">
        <button
          type="button"
          @click="add()"
          v-if="!isEditMode"
          :disabled="btnDisable"
          class="btn btn-primary waves-effect waves-themed"
        >
          <span class="fal fa-check mr-1"></span>追加
        </button>
        <button
          type="button"
          @click="upd(false)"
          v-if="isEditMode"
          :disabled="btnDisable"
          class="btn btn-primary waves-effect waves-themed"
        >
          <span class="fal fa-check mr-1"></span>登録
        </button>
        <button
          type="button"
          @click="delConf()"
          v-if="isEditMode"
          :disabled="btnDisable"
          class="btn btn-danger waves-effect waves-themed"
        >
          <span class="fal fa-times mr-1"></span>削除
        </button>
        <button
          :disabled="btnDisable"
          type="button"
          class="btn btn-secondary waves-effect waves-themed"
          @click="$router.push('/bankAccountList')"
        >
          <span class="fal fa-reply mr-1"></span>戻る
        </button>
      </div>
    </div>
    <!-- Your main content goes below here: -->
    <div class="row">
      <div class="col-xl-12">
        <div id="panel-1" class="panel">
          <div class="panel-hdr">
            <h2>編集項目</h2>
            <div class="panel-toolbar">
              <button
                class="btn btn-panel"
                data-action="panel-collapse"
                data-toggle="tooltip"
                data-offset="0,10"
                data-original-title="Collapse"
              ></button>
              <button
                class="btn btn-panel"
                data-action="panel-fullscreen"
                data-toggle="tooltip"
                data-offset="0,10"
                data-original-title="Fullscreen"
              ></button>
            </div>
          </div>
          <div class="panel-container show">
            <div class="loader">
              <i class="fal fa-spinner-third fa-spin-4x fs-xxl"></i>
            </div>
            <div class="panel-content contents">
              <div class="row">
                <div class="col-md-1 contTitle">口座コード</div>
                <div class="col-md-5 contCnt">
                  <input
                    type="text"
                    name="txtKouzaCd"
                    class="form-control form-control-sm"
                    disabled
                    v-model="delegate.c_bank_id"
                  />
                </div>
              </div>
              <!-------------------->
              <div class="row">
                <div class="col-md-1 contTitle">管轄拠点</div>
                <div class="col-md-5 contCnt">
                  <!-- <vSelect
                    :options="op4ControlBase"
                    :reduce="(label:any) => label.code"
                  ></vSelect> -->
                  <vSelect
                    :options="delegate4list.items4Branch"
                    v-model="delegate.c_branch_id"
                    :reduce="(label:any) => label.c_branch_id"
                    label="c_branch_name"
                  ></vSelect>
                </div>
              </div>
              <!-------------------->
              <div class="row">
                <div class="col-md-1 contTitle">銀行名</div>
                <div class="col-md-5 contCnt">
                  <input
                    type="text"
                    name="txtBankNm"
                    class="form-control form-control-sm"
                    v-model="delegate.c_bank_name"
                  />
                </div>
              </div>
              <!-------------------->
              <div class="row">
                <div class="col-md-1 contTitle">支店名</div>
                <div class="col-md-5 contCnt">
                  <input
                    type="text"
                    name="txtBranch"
                    class="form-control form-control-sm"
                    v-model="delegate.c_bank_branch_name"
                  />
                </div>
              </div>
              <!-------------------->
              <div class="row">
                <div class="col-md-1 contTitle">口座種別</div>
                <div class="col-md-5 contCnt">
                  <vSelect
                    :options="op4BankType"
                    v-model="delegate.c_bank_type"
                    :reduce="(label:any) => label.code"
                  ></vSelect>
                </div>
              </div>
              <!-------------------->
              <div class="row">
                <div class="col-md-1 contTitle">口座番号</div>
                <div class="col-md-5 contCnt">
                  <input
                    type="text"
                    name="txtKouzaNumber"
                    class="form-control form-control-sm"
                    maxlength="10"
                    v-model="delegate.c_bank_number"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 成功通知モーダル -->
    <Mo_modal_alert ref="Mo_modal_success" @modalclosed="get()">
      <template v-slot:title>
        <i class="fal fa-check-circle text-success mr-2"></i>
        <span class="text-success fw-500">{{ message4ModalSuccess }}</span>
      </template>
      <template v-slot:body><br /></template>
      <template v-slot:footer>
        <div class="modal-footer"><br /></div>
      </template>
    </Mo_modal_alert>
    <!-- 成功通知モーダル -->
    <!-- 削除確認モーダル -->
    <Mo_modal_alert ref="Mo_modal_deleteConf">
      <template v-slot:title>
        <i class="fal fa-times-circle text-danger mr-2"></i
        >{{ message4ModalDelConf }}
      </template>
      <template v-slot:body><br /></template>
      <template v-slot:footer>
        <div class="modal-footer">
          <button
            @click="del()"
            type="button"
            class="btn btn-danger shadow-0 bootbox-accept"
          >
            はい</button
          ><button
            @click="closeModal4deleteConf()"
            type="button"
            class="btn btn-default bootbox-cancel"
          >
            いいえ
          </button>
        </div>
      </template>
    </Mo_modal_alert>
    <!-- 削除確認モーダル -->
    <!-- エラー確認モーダル -->
    <Mo_modal_alert ref="Mo_modal_errorConf">
      <template v-slot:title>
        <i class="fal fa-times-circle text-danger mr-2"></i
        >{{ message4ModalErrorConf }}
      </template>
      <template v-slot:body><br /></template>
      <template v-slot:footer>
        <div class="modal-footer">
          <button
            @click="closeModal4ErrorConf()"
            type="button"
            class="btn btn-default bootbox-cancel"
          >
            確認
          </button>
        </div>
      </template>
    </Mo_modal_alert>
    <!-- エラー確認モーダル -->
  </main>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { Cl_common } from "@/functions/Cl_common";
import Mo_modal_alert from "@/components/molecules/Mo_modal_alert.vue";
import { DtoBanksGetResImple } from "furukawa-common/src/common/dto/DtoBanksGetResImple";
import { DtoBanksGetReqImple } from "furukawa-common/src/common/dto/DtoBanksGetReqImple";
import { Cl_bank } from "@/functions/Cl_bank";
import { DtoBanksPutReq } from "furukawa-common/src/common/dto/abst/DtoBanksPutReq";
import { DtoBanksPostReq } from "furukawa-common/src/common/dto/abst/DtoBanksPostReq";
import { DtoMastersGetRes } from "furukawa-common/src/common/dto/DtoMastersGetRes";
import { Cl_master } from "@/functions/Cl_master";
import { DtoMastersgetReq } from "furukawa-common/src/common/dto/DtoMastersGetReq";
import { CONST_OP_4BANK_TYPE } from "furukawa-common/src/common/constant/Constants";

@Options({
  components: {
    vSelect,
    Mo_modal_alert,
  },
})
export default class BankAccountEdit extends Vue {
  //----------------------
  //DOM連携用プロパティ
  //----------------------
  delegate = new DtoBanksGetResImple();
  delegate4list = new DtoMastersGetRes();
  btnDisable = false;
  isEditMode = true;

  //----------------------
  //セレクトボックス用プロパティ
  //----------------------
  op4BankType = CONST_OP_4BANK_TYPE;

  //----------------------
  //モーダル用プロパティ
  //----------------------
  message4ModalSuccess = "";
  message4ModalDelConf = "";
  message4ModalErrorConf = "";

  //----------------------
  //制御用メソッド
  //----------------------
  async mounted() {
    await this.getMastersList();
    await this.get();
  }
  //----------------------
  //基本操作用メソッド
  //----------------------
  /**
   *Masters取得用
   */
  async getMastersList() {
    //ボタン無効＋ローダー表示
    //-----------------
    this.btnDisable = true;
    const panel = document.getElementsByClassName("panel-container");
    Array.from(panel).map((element: Element) => {
      element.classList.add("enable-loader");
    });

    try {
      //処理
      //-----------------
      Cl_common.logger("処理実行社員マスタ取得");

      //準備
      //-------
      let dtoMaster = new DtoMastersgetReq();

      dtoMaster.getStaff = 1;
      dtoMaster.delFlag4staff = 0;

      dtoMaster.getBranch = 1;
      dtoMaster.delFlag4Branch = 0;

      //API実行
      //-------
      this.delegate4list = await Cl_master.get(dtoMaster);
      console.log("this.delegate4list");
      console.log(this.delegate4list);

      //レスポンス処理
      //-------
    } catch (error) {
      //モーダルのメッセージを設定
      this.message4ModalErrorConf = "エラーが発生しました"; //モーダル表示
      const modal: any = this.$refs.Mo_modal_errorConf;
      modal.showModal();

      this.delegate4list = new DtoMastersGetRes();
      Cl_common.logger(error);
    } finally {
      //ボタン無効解除＋ローダー非表示
      //-----------------
      this.btnDisable = false;
      Array.from(panel).map((element: Element) => {
        element.classList.remove("enable-loader");
      });
    }
  }

  async get() {
    //ボタン無効＋ローダー表示
    //-----------------
    this.btnDisable = true;
    const panel = document.getElementsByClassName("panel-container");
    Array.from(panel).map((element: Element) => {
      element.classList.add("enable-loader");
    });

    try {
      //処理
      //-----------------
      Cl_common.logger("処理実行");

      //パラメータにIDが指定されていなければ、新規追加モードでデータを読み込まない
      //-------
      let id = Cl_common.getParam("id");

      if (id == "") {
        //新規追加
        this.isEditMode = false;
        //初期値設定
        this.delegate.c_bank_type = 1;
        return;
      } else {
        //編集
        this.isEditMode = true;
      }

      //準備
      //-------
      let dto = new DtoBanksGetReqImple();

      dto.c_bank_id = Number(id);

      //API実行
      //-------
      this.delegate = await Cl_bank.get(dto);
      //レスポンス処理
      //-------
      //IDがnullなら一覧へ遷移
      if (this.delegate.c_bank_id == null) {
        this.$router.push("/bankAccountList");
      }
    } catch (error) {
      //モーダルのメッセージを設定
      this.message4ModalErrorConf = "エラーが発生しました";
      //モーダル表示
      const modal: any = this.$refs.Mo_modal_errorConf;
      modal.showModal();

      Cl_common.logger(error);
    } finally {
      //ボタン無効解除＋ローダー非表示
      //-----------------
      this.btnDisable = false;
      Array.from(panel).map((element: Element) => {
        element.classList.remove("enable-loader");
      });
    }
  }
  /**
   * データを更新する
   */
  async upd(isDel: boolean) {
    //ボタン無効＋ローダー表示
    //-----------------
    this.btnDisable = true;
    const panel = document.getElementsByClassName("panel-container");
    Array.from(panel).map((element: Element) => {
      element.classList.add("enable-loader");
    });

    try {
      //処理
      //-----------------
      Cl_common.logger("処理実行");

      //準備
      //-------
      let dto = new DtoBanksPutReq();
      if (isDel) {
        //削除処理：削除フラグを立てる。
        dto.c_bank_id = this.delegate.c_bank_id;
        dto.c_bank_flag_del = 1;
      } else {
        //更新処理：delegateからdtoにデータ投入。
        dto = Object.assign(new DtoBanksPutReq(), this.delegate);
      }

      //API実行
      //-------
      await Cl_bank.put(dto);
      //レスポンスの処理
      //-------

      //更新処理：
      //モーダルのメッセージを設定
      if (isDel) {
        //削除処理：
        this.message4ModalSuccess = "正常に削除されました";
      } else {
        //更新処理：
        this.message4ModalSuccess = "正常に変更されました";
      }

      //モーダルを表示
      const modal: any = this.$refs.Mo_modal_success;
      modal.showModal();
    } catch (error) {
      //モーダルのメッセージを設定
      this.message4ModalErrorConf = "エラーが発生しました";
      //モーダル表示
      const modal: any = this.$refs.Mo_modal_errorConf;
      modal.showModal();

      Cl_common.logger(error);
    } finally {
      //ボタン無効解除＋ローダー非表示
      //-----------------
      this.btnDisable = false;
      Array.from(panel).map((element: Element) => {
        element.classList.remove("enable-loader");
      });
    }
  }
  /**
   * データを新たに登録する
   */
  async add() {
    //ボタン無効＋ローダー表示
    //-----------------
    this.btnDisable = true;
    const panel = document.getElementsByClassName("panel-container");
    Array.from(panel).map((element: Element) => {
      element.classList.add("enable-loader");
    });

    try {
      //処理
      //-----------------
      Cl_common.logger("処理実行");

      //準備
      //-------
      let dto = Object.assign(new DtoBanksPostReq(), this.delegate);
      dto.c_bank_flag_del = 0;

      //API実行
      //-------
      const res = await Cl_bank.post(dto);

      //レスポンスの処理
      //-------
      //編集画面のURL作成
      this.$router.push({
        path: "/bankAccountEdit",
        query: { id: res.c_bank_id },
      });

      //モーダルのメッセージを設定
      this.message4ModalSuccess = "正常に追加されました";

      //モーダルを表示
      const modal: any = this.$refs.Mo_modal_success;
      modal.showModal();
    } catch (error) {
      //モーダルのメッセージを設定
      this.message4ModalErrorConf = "エラーが発生しました";
      //モーダル表示
      const modal: any = this.$refs.Mo_modal_errorConf;
      modal.showModal();

      Cl_common.logger(error);
    } finally {
      //ボタン無効解除＋ローダー非表示
      //-----------------
      this.btnDisable = false;
      Array.from(panel).map((element: Element) => {
        element.classList.remove("enable-loader");
      });
    }
  }
  /**
   * データ削除用のモーダルを表示
   */
  async delConf() {
    //モーダルのメッセージを設定
    this.message4ModalDelConf =
      "【" +
      this.delegate.c_bank_id +
      "】" +
      this.delegate.c_bank_name +
      "を削除します。よろしいですか？";
    //モーダル表示
    const modal: any = this.$refs.Mo_modal_deleteConf;
    modal.showModal();
  }
  /**
   * データを削除する
   */
  async del() {
    //削除フラグのあるテーブルなので更新処理。
    this.closeModal4deleteConf();
    this.upd(true);
  }
  //----------------------
  //モーダル用メソッド
  //----------------------
  async closeModal4deleteConf(): Promise<void> {
    const modal: any = this.$refs.Mo_modal_deleteConf;
    modal.closeModal();
  }
  async closeModal4ErrorConf(): Promise<void> {
    const modal: any = this.$refs.Mo_modal_errorConf;
    modal.closeModal();
  }
}
</script>
